module.exports = __webpack_public_path__ + "static/media/Emily Payne.f6e1d085.png";